import Switcher from "common/components/ui/Switcher";
import type { Pricing, PricingPeriodInfo } from "common/types";

function getPricingPeriodLabel({ period, period_unit }: PricingPeriodInfo) {
  if (period_unit === "month") {
    if (period === 1) {
      return "Monthly";
    }
    return `${period} months`;
  }
  return "Yearly";
}

export default function PricingPeriodInfoSelector({
  pricingOptions,
  value,
  setValue,
}: {
  pricingOptions: { addon: Pricing; plan: Pricing }[];
  value: PricingPeriodInfo;
  setValue: (newValue: PricingPeriodInfo) => void;
}) {
  const sortedPricingOptions = pricingOptions.sort((option1, option2) => {
    const days1 =
      (option1.plan.period_unit === "month" ? 30 : 360) * option1.plan.period;
    const days2 =
      (option2.plan.period_unit === "month" ? 30 : 360) * option2.plan.period;
    return days1 - days2;
  });

  return (
    <Switcher
      className="mb-4 mx-auto"
      size="sm"
      options={sortedPricingOptions.map(
        ({ plan: { period, period_unit } }) => ({
          label: getPricingPeriodLabel({ period, period_unit }),
          value: JSON.stringify({ period, period_unit }),
        }),
      )}
      onOptionSelect={(newSelection) => {
        setValue(JSON.parse(newSelection));
      }}
      selectedOption={JSON.stringify(value)}
    />
  );
}
